import Vue from "vue";
import FullscreenUpdate from "@/components/FullscreenUpdate.vue";

let instance = null;
let stopFn = null;
function createInstance(props = {}, fn = null) {
  // 创建挂载点

  const div = document.createElement("div");
  document.body.appendChild(div);
  stopFn = fn;
  const UpdateConstructor = Vue.extend(FullscreenUpdate);
  instance = new UpdateConstructor({
    propsData: {
      visible: true,
      ...props,
    },
  });

  instance.$mount(div);

  // 当组件关闭时清理 DOM
  instance.$on("close", () => {
    typeof stopFn === "function" && stopFn();
    setTimeout(() => {
      instance.$destroy();
      div.remove();
      instance = null;
    }, 300);
  });

  return instance;
}

export default {
  /**
   * 开始显示更新面板
   * @param {Object} props 初始参数
   */
  start(props = {}) {
    if (instance) return instance; // 避免重复创建
    instance = createInstance(props);
    instance.start?.();
    return instance;
  },

  /**
   * 设置进度
   * @param {number} n 进度 (0-100)
   */
  setProgress(n) {
    if (!instance) return;
    instance.setProgress?.(n);
  },

  /**
   * 设置或追加内容
   * @param {string|Array} content 内容
   * @param {boolean} replace 是否替换
   */
  setContent(content, replace = true) {
    if (!instance) return;
    instance.setContent?.(content, replace);
  },
  /**
   * 设置下载失败的情况
   */
  setFailed(url) {
    if (!instance) return;
    instance.setFailed?.(url);
  },

  /**
   * 关闭更新面板
   */
  close() {
    if (!instance) return;
    instance.close?.();
  },
};
